import { render, staticRenderFns } from "./NpaViewSearch.vue?vue&type=template&id=b1220f44&scoped=true"
import script from "./NpaViewSearch.vue?vue&type=script&lang=js"
export * from "./NpaViewSearch.vue?vue&type=script&lang=js"
import style0 from "./NpaViewSearch.vue?vue&type=style&index=0&id=b1220f44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1220f44",
  null
  
)

export default component.exports